<template>
    <div>
        <div class="goback" @click="goback"></div>
    </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        methods:{
            //返回
            goback(){
                this.$router.go(-1);
            },
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/components/goback.vue